import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { scannerWeg } from './sections/scanner-weg';
import { biologischesFundament } from './sections/biologisches-fundament';
import { neurobiologie } from './sections/neurobiologie';
import { praxis } from './sections/praxis';
import { positionierung } from './sections/positionierung';
import { fazit } from './sections/fazit';
import { faq } from './sections/faq';
import { referenzen } from './sections/referenzen';

export const content: BlogPostContent = {
  sections: [
    intro,
    scannerWeg,
    biologischesFundament,
    neurobiologie,
    praxis,
    positionierung,
    fazit,
    faq,
    referenzen
  ]
};
